import React from 'react';
import { Check } from 'lucide-react';
import Reveal from '../ui/Reveal';
import SpotCard from './SpotCard';
import { forYouChecklist } from '../../data/masterclass';

const ForYouSection: React.FC = () => {
  return (
    <section className="relative py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl">
          <div className="mb-4 flex items-center gap-3">
            <span className="text-sm text-white/30">03</span>
            <span className="eyebrow-mc text-mc-electric/90">Para ti si...</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-[1.1] md:text-5xl">
            ¿Te identificas con alguno de estos casos?
          </h2>
        </Reveal>

        <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-[0.82fr_1fr]">
          <Reveal delay={80} className="min-h-[300px] overflow-hidden rounded-[26px] border border-white/10">
            <div className="relative h-full min-h-[300px]">
              <img
                src="/images/06-masterclass/masterclass-5.jpeg"
                alt="Profesionales aprendiendo a trabajar con IA"
                loading="lazy"
                className="absolute inset-0 h-full w-full animate-kenburns object-cover"
              />
              <div
                className="absolute inset-0"
                style={{ background: 'linear-gradient(155deg, rgba(10,20,66,.2), rgba(7,12,36,.85))' }}
              />
              <div
                className="absolute inset-0"
                style={{ background: 'linear-gradient(120deg, rgba(218,35,157,.2), transparent 55%)' }}
              />
              <div className="relative flex h-full items-end p-7">
                <p className="font-display text-lg font-semibold leading-snug text-white">
                  Actualiza tu forma de trabajar y súmate a quienes ya aplican IA con método.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={160}>
            <SpotCard className="rounded-[26px] border border-white/10 bg-white/5 p-8 backdrop-blur-md md:p-10">
              <ul className="grid gap-x-10 gap-y-5 sm:grid-cols-2">
                {forYouChecklist.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <Check size={20} className="mt-0.5 shrink-0 text-mc-fuchsia" />
                    <span className="text-white/80">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="my-8 h-px bg-white/10" />
              <p className="font-display text-lg font-bold md:text-xl">
                No necesitas conocimientos avanzados de IA para <span className="text-gradient-mc">participar.</span>
              </p>
            </SpotCard>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ForYouSection;
